<template>
  <div class="modal">
    <div class="control">
      <a @click="this.$emit('close')"
        ><img src="@/assets/icons/close.svg" alt="close"
      /></a>
    </div>
    <div class="slot">
      <slot>
        <!-- Default content -->
        <tt>Nothing to see here.</tt>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalClipRight",
};
</script>

<style scoped>
.modal {
  position: absolute;
  z-index: 10;
  top: 0;
  right: 10px;
  min-width: 150px;
  width: min-content;
  height: min-content;
  background-color: var(--primary-bg);
  border: 1px solid var(--border);
  border-radius: 1em;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: end;
  overflow: hidden;
}

.control {
  padding: 1em 1em;
  display: flex;
  align-items: center;
}

.slot {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  justify-content: stretch;
  align-items: start;
}
</style>
